module.exports = __webpack_public_path__ + "img/cart-empty-state.30b94901.svg";